let TelegramUser = null;

if (window.Telegram && window.Telegram.WebApp) {
  const user = window.Telegram.WebApp.initDataUnsafe?.user;
  if (user) {
    TelegramUser = user;
  }
}

// test
// TelegramUser = {
//   username: "y_rw2",
//   chatid:"1234",
// };

export default TelegramUser;
